var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _g, _rect29, _g2, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _path2, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _path3, _path4, _path5, _path6, _rect71, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChooseShg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 170,
    viewBox: "0 0 350 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F9D852"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F9D852"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F8D853"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 5C210 2.23858 212.239 0 215 0H225C227.761 0 230 2.23858 230 5V15C230 17.7614 227.761 20 225 20H215C212.239 20 210 17.7614 210 15V5Z",
    fill: "#191B20"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 30,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#1A1C21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_18_84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#3C775B"
  }))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#3C775B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_18_84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#3C775B"
  }))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#3C775B"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 60,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270 95C270 92.2386 272.239 90 275 90H285C287.761 90 290 92.2386 290 95V105C290 107.761 287.761 110 285 110H275C272.239 110 270 107.761 270 105V95Z",
    fill: "#191B20"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 90,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F9D852"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F9D852"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F9D852"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F9D852"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#F9D852"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 120,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 150,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#191B20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190 91.1475V72.5L203.496 86.0289H195.601L195.122 86.1733L190 91.1475Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.578 91.9327L196.38 93.72L190.929 80.8082L195.22 78.9999L200.578 91.9327Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.025 91.1401L196.878 92.0413L193.268 83.4552L195.412 82.5528L199.025 91.1401Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.164 75.3028V88.3299L194.622 84.9928L195.12 84.8309H200.672L191.164 75.3028Z",
    fill: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 170,
    fill: "url(#paint0_radial_18_84)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_18_84",
    x: 129,
    y: 39,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_18_84"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.466667 0 0 0 0 0.352941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_84",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_18_84"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_18_84",
    x: 159,
    y: 39,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_18_84"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.466667 0 0 0 0 0.352941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_84",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_18_84"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_84",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175 85) rotate(90) scale(112.5 231.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F8F7F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F7F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseShg);
export default __webpack_public_path__ + "static/media/ChooseSHG.d229016a0df74b934a8dd2ac9d19b68b.svg";
export { ForwardRef as ReactComponent };